// extracted by mini-css-extract-plugin
export default {"search":"materials_search__qX3f-","fieldList":"materials_fieldList__KukPP","field":"materials_field__3vrgC","count":"materials_count__IqkDz","list":"materials_list__ofJ+E"};